import { render, staticRenderFns } from "./MailboxEis.vue?vue&type=template&id=36ff9e3e&"
import script from "./MailboxEis.vue?vue&type=script&lang=js&"
export * from "./MailboxEis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports